module.exports = function requiredIf(type, condition) {
  return function(props) {
    var test = condition(props) ? type.isRequired : type;
    return test.apply(this, arguments);
  };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-required-if/index.js
// module id = 960
// module chunks = 0